const clearBrowserStorage = {
  removeUserRef() {
    sessionStorage.clear();
    localStorage.clear();
  },
};

export { clearBrowserStorage };
